import { type PropsWithChildren } from 'react'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'

import type { Styles } from '../../theme/types/Styles'

type Props = PropsWithChildren<{
  sx?: Styles
}>

export default function StyledDetailsTable({ children, sx }: Props) {
  return (
    <Table
      sx={{
        m: '40px',
        verticalAlign: 'top',
        maxWidth: 650,
        '& td': {
          p: 0.5,
          fontSize: 18,
          borderBottom: '0px solid',
          fontWeight: 200,
        },
        '& td:first-of-type': {
          width: 219,
          fontWeight: 'bold',
        },

        ...sx,
      }}
    >
      <TableBody>{children}</TableBody>
    </Table>
  )
}
